import _ from "lodash";
import { LABEL_KELAS, LABEL_MAPEL, LABEL_MURID, LABEL_SEKOLAH } from "./helpers/constant";

export default [
		/**
		 * ================
		 * KARYAWAN
		 * ================
		 */	
		{ id: "JADWAL", type: "dropdown", menu: "Jadwal Ujian", to: "/jadwal" },
		{ parent: "JADWAL", id: "JADWAL#DJADWAL", menu: "Daftar Jadwal Ujian", to: "/jadwal" },
		{ parent: "JADWAL", id: "JADWAL#DJADWAL#BARU", menu: "Jadwal Ujian Baru", icon: "calendar plus", to: "/jadwal/baru" },
		
		{ id: "BANKSOAL", type: "dropdown", menu: "Bank Soal", to: "/bank-soal" },
		{ parent: "BANKSOAL", id: "BANKSOAL#DPAKET", menu: "Daftar Bank Soal", to: "/bank-soal" },
		{ parent: "BANKSOAL", id: "BANKSOAL#DPAKET#BARU", menu: "Paket Soal Baru", icon: "book", to: "/bank-soal/baru" },
		
		// { id: "HASIL", type:"dropdown", menu: "Nilai Ujian", to: "/hasil-ujian" },
		{ id: "HASIL", type: "button", menu: "Nilai Ujian", to: "/hasil-ujian" },
		{ parent: "HASIL", id: "HASIL#DHASIL", menu: "Nilai Ujian", to: "/hasil-ujian" },
		// { parent: "HASIL", id: "HASIL#DHASILPAKET", menu: "Hasil Paket Soal", to: "/hasil-ujian/paket" },
		
		{ id: "PENGATURAN", type: "dropdown", menu: "Pengaturan", to: `/pengaturan/akun-${_.toLower(LABEL_MURID)}` },
		{ parent: "PENGATURAN", id: "SET#DMURID", menu: `Akun ${LABEL_MURID}`, to: `/pengaturan/akun-${_.toLower(LABEL_MURID)}` },
		{ parent: "PENGATURAN", id: "SET#DKARYAWAN", menu: "Akun Karyawan", to: "/pengaturan/akun-karyawan" },
		{ parent: "PENGATURAN", id: "SET#DKELAS", menu: `Daftar ${LABEL_KELAS}`, to: `/pengaturan/daftar-${_.toLower(LABEL_KELAS)}` },
		{ parent: "PENGATURAN", id: "SET#DMAPEL", menu: `Daftar ${LABEL_MAPEL}`, to: `/pengaturan/daftar-${_.toLower(LABEL_MAPEL)}` },
		{ parent: "PENGATURAN", id: "SET#IDENTITAS", menu: `Identitas ${LABEL_SEKOLAH}`, to: `/pengaturan/identitas-${_.toLower(LABEL_SEKOLAH)}` },
		// { parent: "PENGATURAN", id: "SET#UMUM", menu: "Statistik Penggunaan", icon: "chart bar", to: "/pengaturan/statistik-penggunaan" },

		// { id: "KELAS", logo: "imp imp-kelompok", menu: "Kelas & Kelompok" },
		// { parent: "KELAS", id: "KELAS#DKELAS_KELAS", menu: "Daftar Kelas", to: "/kelas/daftar-kelas" },
		
		// { id: "HASIL#DHASIL", type: "button", menu: "Nilai Hasil", to: "/hasil-ujian" },
		//========================================================================

		/**
		 * ================
		 * MURID
		 * ================
		 */

		{ id: "IKHTISAR", logo: "imp imp-ikhtisar", menu: "Ikhtisar" },
		{ parent: "IKHTISAR", id: "IKHTISAR#UMUM", menu: "Ikhtisar Umum", to: "/ikhtisar/umum" },
		//========================================================================
	]